import { FormControl, FormHelperText, FormLabel } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

export const FormLine = styled('article')(() => ({
  display: 'flex',
  alignItems: 'center',

  '& > div': {
    flex: '1',

    '&:not(:last-of-type)': {
      marginRight: '1rem'
    }
  }
}));

const StyledFormElement = styled('div')(({ theme }: any) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  margin: '0.5rem 0',

  '.MuiFormControl-root': {
    display: 'flex',
    flex: 1,
    marginBottom: '1rem',

    '&:last-child': {
      marginBottom: 0
    },

    '&.MuiTextField-root': {
      flex: 1
    },

    legend: {
      position: 'absolute',
      top: '-5px',
      left: '10px',
      padding: '0 0.5rem',
      marginBottom: '0.5rem',
      color: theme.palette.grey.main,
      fontSize: '1.2rem',
      background: 'white',
      zIndex: 10
    }
  }
}));

const StyledFormLabel = styled(FormLabel)(() => ({
  maxWidth: '90%',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden'
}));

export const FormElement = ({
  label = '', icon, required = false, helperText = '', error, children
}: {
  children: any,
  error?: any,
  helperText?: string,
  icon?: any,
  label?: string,
  required?: boolean
}) => (
  <StyledFormElement>
    <FormControl component="fieldset" error={error} required={required}>
      {label && (
        <StyledFormLabel>
          {label}
          {icon}
        </StyledFormLabel>
      )}
      {children}
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  </StyledFormElement>
);
